import React from "react";
import "./About.css";
import { FiLock } from "react-icons/fi";
import myimg from "../../Assets/SahilImage.jpg";
import { Button } from "antd";

export default function About() {
  return (
    <>
      <div className="abt">
        <div className="abtlink">
          {" "}
          <FiLock style={{ marginLeft: "10px", marginTop: "3px" }} />{" "}
          <div style={{ textAlign: "center", width: "30vw" }}>
            sahilrohera.portfolio/aboutme
          </div>
        </div>
        <div className="aboutmain">
          <div className="about1">
            <div className="bordercolor"></div>
            <img src={myimg} alt="" />
          </div>
          <div className="about2">
            {/* <h1 className="abthead">About Me</h1> */}
            <div className="abtcontent">
              <p>
                I am a passionate and highly motivated Software Developer
                pursuing a B.Tech. in Information Technology from Maharaja
                Agrasen Institute of Technology.
              </p>
              <p className="hideit">
                My journey into the world of technology began with a strong
                foundation in C++ and my development skills , I have honed my
                problem-solving skills through 350+ problem-solving on platforms
                like Leetcode and GeeksforGeeks.
              </p>
              <p className="hide2">
                With a strong foundation in computer science and a passion for
                solving complex problems, I am eager to contribute my skills and
                dedication to innovative projects and become a valuable asset to
                any team.
              </p>
            </div>
            <div className="buttons">
              {/* <Button size="large" href="mailto:sahilrohera10@gmail.com">
                Contact Me
              </Button> */}
              <Button
                style={{ background: "#EE833C" }}
                size="large"
                type="primary"
              >
                Download Resume
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
